/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'no alert': {
    width: 16,
    height: 16,
    viewBox: '0 0 56.22 64.38',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M54.15 6.15L.58 59.72M13.16 53.6h41.46a1 1 0 0 0 .86-.47 1 1 0 0 0 .07-1l-4.66-10M48 12.28A22.77 22.77 0 0 0 5.34 23.35a.91.91 0 0 0 0 .17 1 1 0 0 0 0 .17v18.47l-4.66 10a1 1 0 0 0 .92 1.44h5m44.28-20.05v-9.86a.91.91 0 0 0 0-.17 1 1 0 0 0 0-.17 22.75 22.75 0 0 0-.65-5.43M19.18 57.34c0 3.56 4 6.46 8.92 6.46S37 61 37 57.34"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/no alert.js